import React from 'react';
import FileConverter from './FileConverter';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <FileConverter />
      </header>
    </div>
  );
}

export default App;
